export default "__VITE_PUBLIC_ASSET__a49f09b1__"